const logging = require('@sstdev/lib_logging');
const errors = require('@sstdev/lib_errors');

// *******************************************************************************************
// This stuff up here is mostly to get this library to work regardless of whether it is running
// on the server, browser or react-native.

// eslint-disable-next-line no-undef
const isReactNative = typeof __SST_REACT_NATIVE__ !== 'undefined' && __SST_REACT_NATIVE__;
// eslint-disable-next-line no-undef
const isBrowser = typeof __INSIDE_BROWSER__ !== 'undefined' && __INSIDE_BROWSER__;

let jwt;
if (!isBrowser && !isReactNative) {
    jwt = require('jsonwebtoken');
} else {
    // JWT is not needed in browser or react native - and (if you try to include it) will create a lot of unnecessary
    // junk which takes up space in the client side build.
    const message = () => {
        throw new Error('The jwt.sign and jwt.decode methods are unsupported on this platform');
    };
    jwt = {
        sign: message,
        verify: message
    };
}
// *******************************************************************************************

module.exports = {
    decode,
    sign
};

//synchronous
function decode(token, secret) {
    let payload;
    try {
        payload = jwt.verify(token, secret);
    } catch (err) {
        logging.error('Temporary token could not be decoded and is invalid');
        logging.error(err);
        //in future, possibly send hack warning event here to Rules engine, or log with special note?
        throw new errors.InvalidTokenError('Temporary token could not be decoded and is invalid');
    }
    return payload;
}

//synchronous
function sign(payload, secret) {
    return jwt.sign(payload, secret);
}
